// *** Create Post Component ****
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import thumb from "../../assets/img/post/add-pop-thumb.svg"
import {
  savePost, editPost,
} from "../../services/apiPosts";
import "../../assets/css/style.css";
import Validation from "../../commonComponents/Validation";
import ResponsePopup from "../../commonComponents/responseSucessPopup";
const EditDiscussion = (props) => {
 const [errors, setErrors] = useState({});
 const[isSucess,SetSucess]=useState(false);
  const[ResponseMessage,SetResponseMessage]=useState("");
  const userData = JSON.parse(localStorage.getItem('userData'));
  const closePopup = () => {
    props.closePop();
    setErrors(false);
    setErrors({});
    setFormData({
      communityid: "",
      topicid: "",
      subject: "",
      organizationid:"",
      post: ""
    });

  };
  const [formData, setFormData] = useState({
    post: "",
    
  });


  useEffect(() => {
    if (props.EditStatus && props.EditFeed) {
      setFormData({

        post: props.EditFeed.postDescription || "",
      });
      setErrors({});
    } else {
      setFormData({

        post: "",
      });

      setErrors({});

    }
  }, [props.EditStatus, props.EditFeed]);


  const handleChange = async (event) => {

    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));


    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '', // Clear only the error for the current field
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.post) newErrors.post = true;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSavePost = async (event) => {

    event.preventDefault();
    if (!validateForm()) return;
    formData.userid = userData._id;

    let response;
    try {
      if (props.EditStatus === true) {
        formData.postid = props.EditFeed._id;
        response = await editPost(formData);
         if (response.status === false){

           SetSucess(true);
         SetResponseMessage(response.message);
         }
      }
      else{
          formData.organizationid = props.Organiationid;
         response = await savePost(formData);
          if (response.status === false){

           SetSucess(true);
         SetResponseMessage(response.message);
         }
      }
       
      if (response.status === true) {
        formData.post="";
        props.closePop();
        if(props.source === "profile")
        props.fetchAllFeeds({userid:userData._id,offset: 0,limit: 10});
        else
        props.fetchAllDiscussions({ userid: userData._id, organizationid: props.Organiationid,offset: 0,limit: 20});
       
      }
    } catch (error) {


      console.log(error);
    }

  };

  return (
    <div>
      <Modal dialogClassName="custom-modal modal-dialog-centered" show={props.openPop} onHide={closePopup}>
        <Modal.Header closeButton>
          <div className="popupheader">
            <div className="mod-bor-icon" >
              <img src={thumb} className="mod-icon"></img>
            </div>
            <div className="header">
              <h4 className="modal-tittle">{props.EditStatus ? "Edit a Discussion" : "Create a Discussion"}</h4>

            </div>
          </div>
        </Modal.Header>

        <Modal.Body>


          <div className="col-sm-12">
            <div className="form-group custom-form-group">
              <textarea
                name="post"
                id="post"
                onChange={handleChange}
                className="post-textarea form-control"
                value={formData.post}
              />
            </div>
          </div>
          {errors.post && (
            <Validation message={'Please Enter Post Content'} />
          )}


          <div className="d-flex justify-content-between">

          </div>

        </Modal.Body>
        <Modal.Footer className="full-w" >
          <button
            type="button"
            className="cancel-btn"
            onClick={() => {
              closePopup();
            }}
          >
            Cancel
          </button>

          <button className="next-btn" onClick={(e) => handleSavePost(e)}>
            {" "} {props.EditStatus ? "Update Discussion" : "Post Now"}{" "}
          </button>
        </Modal.Footer>
      </Modal>
      {isSucess && (<ResponsePopup 
                            isSucess={isSucess} 
                            CancelPopup={() => { 
                             SetSucess(false);
                            }} 
                            message={ResponseMessage}
                          />)}
    </div>
  );
};
export default EditDiscussion;